import React from "react";
import { Link } from "react-navi";
import styles from "./BlogHeader.module.css";

function BlogHeader({ blogRoot }) {
  return (
    <header className={styles.header}>
      <div className={styles.inner}>
        <div className={styles.left}>
          <a
            className={styles.logo}
            href="https://imagetext.xyz/"
            target="_blank"
            rel="noopener noreferrer"
          >
            IMAGETEXT.XYZ
          </a>
          <span className={styles.pill}>
            <span className={styles.statusDot} />
            OCR Studio
          </span>
        </div>

        <nav className={styles.nav}>
          <Link className={styles.navLink} href={blogRoot}>
            Blog
          </Link>
          <Link className={styles.navLink} href="/tags">
            Tags
          </Link>
          <Link className={styles.navLink} href="/about">
            About
          </Link>
          <a
            className={styles.cta}
            href="https://imagetext.xyz/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Open OCR Tools
          </a>
        </nav>
      </div>
    </header>
  );
}

export default BlogHeader;
